module.exports = __webpack_public_path__ + "static/media/img-print-qr.1d0752fb.svg";